/** @flow */

import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { ColumnsContainer } from "@components";
import { formatDate } from "@transformers/date";
import { getStaffGroupsLabels } from "@modules/shared/selectors/staff-groups";
import type { State } from "@store/reducers";

type OwnProps = $Exact<{
  data: Object,
}>;

type PropsFromState = $Exact<{
  staffGroups: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

export class StepFiltersView extends React.Component<Props> {
  get filtersOptions() {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("REPORT_FILTER_DATE_RANGE"),
                this.props.data.dateRange
                  ? this.props.t(this.props.data.dateRange)
                  : this.props.t("CUSTOM"),
              ],
              [
                this.props.t("REPORT_FILTER_TREND_TYPE"),
                this.props.data.trendType
                  ? this.props.t(this.props.data.trendType)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("GENDER"),
                this.props.data.gender ? this.props.t(this.props.data.gender) : this.props.t("ALL"),
              ],
              [this.props.t("STAFF_GROUPS"), this.props.staffGroups],
            ],
          },
          {
            data: [
              [
                this.props.t("FROM_DATE"),
                this.props.data.fromDate ? formatDate(this.props.data.fromDate) : "",
              ],
              [
                this.props.t("ABSENCE_TYPE"),
                this.props.data.absenceType
                  ? this.props.t(this.props.data.absenceType)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("PERIOD_TYPE"),
                this.props.data.periodType
                  ? this.props.t(this.props.data.periodType)
                  : this.props.t("ALL"),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("TO_DATE"),
                this.props.data.toDate ? formatDate(this.props.data.toDate) : "",
              ],
              [
                this.props.t("REPORT_FILTER_ABSENCE_LENGTH"),
                this.props.data.absenceLength
                  ? this.props.t(this.props.data.absenceLength)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("AGE_GROUP"),
                this.props.data.ageGroup
                  ? this.props.t(this.props.data.ageGroup)
                  : this.props.t("ALL"),
              ],
              [
                this.props.t("TRENDS_COMPLIANCE_OPTIONS_GROUP_BY"),
                this.props.data.groupBy
                  ? this.props.t(this.props.data.groupBy)
                  : this.props.t("ALL"),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer className="w-100" rows={this.filtersOptions} />;
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps): PropsFromState => ({
  staffGroups: getStaffGroupsLabels(
    state,
    (ownProps.data.staffGroups || []).map(staffGroup => staffGroup.id),
  ),
});

export default compose(connect(mapStateToProps), localize())(StepFiltersView);
